module.exports = __webpack_public_path__ + "static/media/breadcrumb-trail.c82e7175.jpg";